import { emailToUsername, normalizeEmail } from './emailUtils';
import { formatDisplayPersonName } from './formatPersonName';
import type { AllowedEmail, CrmUser } from '../types/crm';

export const ALLOWLIST_SELECT =
  'id, email, display_name, role, username, auth_id, created_at';

/** Application Form allowlist only — includes organizational department. */
export const FORMS_ALLOWLIST_SELECT = `${ALLOWLIST_SELECT}, department_id`;

/** Map allowlist row → CRM team member (replaces public.users). */
export function allowlistRowToCrmUser(row: AllowedEmail): CrmUser {
  const username = row.username?.trim() || emailToUsername(row.email);
  return {
    id: row.auth_id ?? row.id,
    username,
    display_name: formatDisplayPersonName(row.display_name?.trim() || username),
    role: row.role,
    email: normalizeEmail(row.email),
  };
}

export function allowlistRowsToCrmUsers(rows: AllowedEmail[]): CrmUser[] {
  return rows.map(allowlistRowToCrmUser);
}
